// q_auto:eco = qualité automatique agressive (~10-15% plus light que q_auto)
// fl_progressive = JPEG progressif (perception rapide + parfois plus léger)
// fl_immutable_cache = hint CDN pour cache long terme sur les variants
//                     (les transformations sont déterministes, immuables)
// c_limit = ne scale jamais up : si l'image source < cible, sert l'original
//           (évite des octets inutiles)
// c_fill (thumb) = crop fill carré pour cohérence visuelle des cards
const COMMON = "f_auto,q_auto:eco,fl_progressive,fl_immutable_cache";
const VARIANTS = {
  thumb: `w_400,c_fill,${COMMON}`,
  medium: `w_800,c_limit,${COMMON}`,
  full: `w_1200,c_limit,${COMMON}`,
};

// Insère une transformation Cloudinary dans une secure_url.
// "https://res.cloudinary.com/<cloud>/image/upload/v123/.../abc.jpg"
//  -> "https://res.cloudinary.com/<cloud>/image/upload/<transform>/v123/.../abc.jpg"
export function cdnUrl(url, variant = "thumb") {
  if (!url || typeof url !== "string") return url;
  const transform = VARIANTS[variant];
  if (!transform || !url.includes("/upload/")) return url;
  return url.replace("/upload/", `/upload/${transform}/`);
}

// Encode un tableau d'octets en base64 par chunks. String.fromCharCode(...arr)
// dépasse la call stack pour un buffer >~100KB ("Maximum call stack size exceeded").
function bytesToBase64(arr) {
  const CHUNK = 8192;
  let binary = "";
  for (let i = 0; i < arr.length; i += CHUNK) {
    binary += String.fromCharCode.apply(null, arr.slice(i, i + CHUNK));
  }
  return btoa(binary);
}

// Renvoie la src à utiliser pour un product / event :
// 1. imageUrl Cloudinary avec transformation si présent (préféré)
// 2. fallback base64 sur image.data + contentType (legacy)
// 3. null si rien
export function getImageSrc(item, variant = "thumb") {
  if (!item) return null;
  if (item.imageUrl) return cdnUrl(item.imageUrl, variant);
  const data = item.image?.data;
  const ct = item.image?.contentType;
  if (data && ct) {
    let b64;
    if (typeof data === "string") b64 = data;
    else if (Array.isArray(data)) b64 = bytesToBase64(data);
    else if (data.data && Array.isArray(data.data))
      b64 = bytesToBase64(data.data);
    else return null;
    return `data:${ct};base64,${b64}`;
  }
  return null;
}
